import { ASSET_PREFIX } from 'utils/constants';

const TrendingPrizeCard = ({ prize, isHeroCard, onClick }) => (
  <div className={isHeroCard ? 'card hero' : 'card'} onClick={onClick ?? (() => {}) }>
    <img
      src={prize.heroImageLocation}
      className='backgroundImage'
      alt=""
    />

    <img
      src={`${ASSET_PREFIX}/images/prizes/${isHeroCard ? "top-pick" : "trending"}-badge.svg`}
      alt={isHeroCard ? "most popular" : "trending"}
      className='mostPopularBadge'
    />

    <p className='plus'>
      +
    </p>

    <div className='textContainer'>
      <div className='title'>
        { prize.title }
      </div>

      <div className='subheading'>
        { prize.subheading }
      </div>
    </div>

    <style jsx>
      {`
        .card {
          flex: 1;
          min-width: 150px;
          height: 300px;
          cursor: ${onClick ? 'pointer' : 'default'};
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          position: relative;
          color: white;
          overflow: hidden;
        }
        
        .card.hero {
          height: 400px;
        }
        
        .card .backgroundImage {
          object-fit: cover;
          object-position: center;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          transition: 0.5s;
          z-index: 0;
        }
        
        .card:hover .backgroundImage {
          transform: scale(1.1);
          filter: brightness(75%);
        }
        
        .mostPopularBadge {
          position: absolute;
          top: 20px;
          left: 20px;
          height: 40px;
          z-index: 1;
        }
        
        .plus {
          position: absolute;
          top: -5px;
          right: 10px;
          font-size: 3em;
          font-weight: 100;
          z-index: 1;
        }
        
        .textContainer {
          background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 50));
          padding: 2em 1em 1em 1em;
          z-index: 1;
        }
        
        .title {
          font-weight: 800;
          font-size: 1.1rem;
        }
        
        .subheading {
          font-weight: 600;
          font-size: 1.0rem;
        }
        
        @media(min-width: 800px) {
          .card {
            height: 400px;
          }
          
          .card.hero {
            height: 600px;
          }
          
          .textContainer {
            padding: 4em 2em 2em 2em;
          }
          
          .title {
            font-size: 1.2rem;
          }
        
          .subheading {
            font-size: 1.1rem;
          }
        }
      `}
    </style>
  </div>
);

export default TrendingPrizeCard;